import { useEffect, useState, useRef } from 'react';
import { useFormik, FormikProvider } from 'formik';
import PagoCaja from "./componentes/PagoCaja";
import { axiosInstance } from "../../components/helpers/axiosInstance"
import TitleTooltip from "../../components/helpers/TitleTooltip";
import { validacionOtrosConceptos } from "./validaciones/validacionesCorte";
import ErrorMessage from "../../components/helpers/ErrorMessage";
import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';
import dayjs from "dayjs";
import es from 'dayjs/locale/es'
import TablaCorte from "../../components/helpers/TablaCorte";
import CardCorte from "../../components/helpers/CardCorte";
import { useToast } from "../../components/notificaciones/ToastProvider";
import { CajasCompletas } from "../../components/catalogo/Cajas";
import { nombreTipoPago } from "./BusquedasRealizadas";
/**
 * COMPONENTE PRINCIPAL
 * @returns {JSX.Element}
 * @constructor
 */
export default function IngrsEgrs(){
    /**
     * Datos de la tabla consulta
     */
    const [ingreso, setIngreso] = useState([]);
    /**
     * Fecha del día actual
     * @type {Date}
     */
    const date = new Date();

    /**
     * Necesario para notificaciones (toast)
     * @type {undefined}
     * @property setArrayToast
     */
    const toast = useToast();

    /**
     * @function onSubmit enviar datos de formulario
     * @param values
     */
  function onSubmit( values ){

    /**
     * Hacer petición al servidor
     */
    axiosInstance.post(
       '/cajas/' + values.id_caja + '/movimientos',
      {
        movimiento: values.movimiento,
        monto: values.monto,
        factura: values.factura,
        forma_pago: values.forma_pago,
        concepto: "OTROS",
        observaciones: values.observaciones,
    }
    ).then(function (response) {
          setIngreso([...ingreso,response.data]);
            /**
            * Notificación : sí se hizo el registro correctamente se muestra el dialogo de confirmación
            */
            toast.setArrayToast(
                prevState => [
                    ...prevState,
                    {
                        id : response.data.id,
                        text : "Se registro el movimiento",
                        color : "success",
                        show : true,
                    }
                ]
            );
            /**
             * Devolver formulario a sus valores iniciales
             */
            formik.resetForm();
    }).catch(function (error) {
        /**
         * Notificación : guardar y mostrar error de API
         */
        toast.setArrayToast(
            prevState => [
                ...prevState,
                {
                    id : 'error',
                    text : error.response.data.errors[0].message,
                    color : "danger",
                    show : true,
                }
            ]
        );

        /**
         * Asignar errores a los inputs
         */
        formik.setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);
    });
  }

    /**
     * @const valorInicial objeto de valores iniciales del formulario
     * @type {{movimiento: string, fecha: Date, id_caja: number, observaciones: string, forma_pago: string, factura: string, monto: string}}
     */
  const valorInicial = {
    movimiento: "I",
    fecha:  date,
    id_caja: 1,
    observaciones: "",
    forma_pago: "TR",
    factura: "",
    monto: "",
  }

    /**
     * @const formik necesarias para el control de formulario
     */
  const formik = useFormik({
        initialValues: valorInicial,
        validationSchema: validacionOtrosConceptos,
        validateOnMount: true,
        onSubmit,
  });

    const { values, setFieldValue } = formik;

    useEffect(() => {
        if (values.movimiento === "G"){
            setFieldValue('forma_pago', 'EF');
        }
    }, [values, setFieldValue]);


  return (
    <>
        <style type={'text/css'}>
            {`
                    .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
                        color : var(--bs-gray-700)!important;
                    }
                `}
        </style>
        <CardCorte>
            <div className="card card-bordered d-flex flex-row-fluid flex-center">
                <FormikProvider value={formik}>
                    {
                        /**
                         * Formulario para el registro de ingresos/egresos
                         */
                    }
                    <form onSubmit={formik.handleSubmit} className="card-body py-15 w-100 px-10">
                        <div className={'row'}>
                            <PagoCaja formik={formik} mov={true}></PagoCaja>
                        </div>
                        <div className='row mb-2'>
                            <div className={'col-md-6 mb-7'}>
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control form-control-solid"
                                        id="observaciones"
                                        name="observaciones"
                                        value={values.observaciones}
                                        placeholder="Descripción de movimiento"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="observaciones" className={"text-gray-700"}>Observaciones</label>
                                </div>
                            </div>
                            <div className={'col-md-2'}>
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control form-control-solid"
                                        id="monto"
                                        name="monto"
                                        value={values.monto}
                                        placeholder="Total de búsquedas"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="monto" className={"text-gray-700"}>Monto</label>
                                </div>
                                <ErrorMessage name={'monto'}></ErrorMessage>
                            </div>
                            <div className={'col-md-2 mb-7'}>
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control form-control-solid"
                                        id={'factura'}
                                        name={'factura'}
                                        value={values.factura}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="factura" className={"text-gray-700"}>Factura</label>
                                </div>
                                {/*<div className="d-flex flex-stack">*/}
                                {/*    <div className="form-check form-switch form-check-reverse d-flex align-items-center p-0">*/}
                                {/*        <label htmlFor={'factura-switch'} className="fw-bold text-gray-700 fs-5 text-end me-2">Factura</label>*/}
                                {/*        <input id={'factura-switch'} className="form-check-input w-30px h-15px m-0" type="checkbox" checked={values.factura} onChange={(e) => setFieldValue('factura',e.target.checked)}/>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                        <div className={'d-flex justify-content-end mt-2'}>
                            <button className="btn btn-primary me-3 " type="submit"
                                    disabled={Object.keys(formik.errors).length > 0}
                            >
                                Enviar
                            </button>
                        </div>
                    </form>
                    {
                        /**
                         * FIN : Formulario para el registro de ingresos/egresos
                         */
                    }
                </FormikProvider>
            </div>
            <div className="card card-bordered d-flex flex-row-fluid flex-center mt-5">
                {
                    /**
                     * Consultar ingresos o egresos
                     */
                }
                <TablaIngreso ingreso={ingreso} setIngreso={setIngreso} date={date}></TablaIngreso>
                {
                    /**
                     * FIN : Consultar ingresos o  egresos
                     */
                }
            </div>
        </CardCorte>
    </>
  );
}

////////////// FIN COMPONENTE : PRINCIPAL /////////////
/**
 * COMPONENTE :  TABLA DE INGRESOS O EGRESOS
 * @param ingreso
 * @param setIngreso
 * @returns {JSX.Element}
 * @constructor
 */
function TablaIngreso({ingreso, setIngreso}) {
    /**
     * Cambiar lenguaje de libreria dayjs
     */
    dayjs.locale(es);
    /**
     * Hook de notificación
     * @type {undefined}
     * @property setArrayToast
     */
    const toast = useToast();
    /**
     * Valores iniciales del formulario
     * @type {{caja_tabla: number, movimiento: string, concepto: string}}
     */
    const valorInicial = {
        caja_tabla : 100,
        movimiento : 'egresos',
        concepto : 'otros'
    };
    /**
     * @function onSubmit no es necesaria pero aparece un warning si no se pone
     * @param values
     */
    const onSubmit = (values) => { console.log(values); };
    /**
     * @const formik ayuda al manejo del formulario
     */
    const formik = useFormik({
        initialValues: valorInicial,
        onSubmit
    });
    /**
     * Desestructuración de valores
     */
    const { setFieldValue,values } = formik;
    /**
     * Egresos solo puede tener como concepto a "otros"
     */
    useEffect(() => {
        if (values.movimiento === "egresos"){
            setFieldValue('concepto', 'otros');
        }
    }, [values.movimiento, setFieldValue]);
    /**
     * Hace la petición cada vez que cambian los valores de los select
     */
    useEffect(() => {

        axiosInstance.get("/cajas/" + values.caja_tabla + "/movimientos?movimientos=" + values.movimiento  + ",egresos&conceptos=" + values.concepto)
          .then((res) =>{
              setIngreso(res.data);
          }).catch((error) => console.log(error));

    },[values, setIngreso]);
    /**
     * @function handleDeleteRow eliminar registro
     * @param rowItem
     */
    function handleDeleteRow(rowItem){
        axiosInstance.delete("/cajas/" + values.caja_tabla + "/movimientos/" + rowItem)
        .then((res) =>{
            if(res.status === 204){
                /**
                 * Quitar dato de array y tabla
                 */
                setIngreso( ingreso.filter((i) => i.id !== rowItem));
                /**
                 * Notificación : Se elimino correctamente
                 */
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id: rowItem,
                            text: "Movimiento eliminado",
                            color: "success",
                            show: true,
                        }
                    ]
                )
            }
        }).catch((error) => {
            /**
             * Notificación : Sí la respuesta es 404 significa que el usuarion no tiene accesos a esa caja
             */
            if (error.status === 404) {
                toast.setArrayToast(prevState => [
                    ...prevState,
                    {
                        id: rowItem,
                        text: "Usuario sin acceso, el administrador del sistema sera notificado.",
                        color: "danger",
                        show: true,
                    }
                ])
                /**
                 * Notificación : Cualquier otra cosa se muestra el mensaje de error
                 */
            } else {
                toast.setArrayToast(prevState => [
                    ...prevState,
                    {
                        id  : rowItem,
                        text : error.message,
                        color: "danger",
                        show: true,
                    }
                ])
            }
        });
    }
  return (
    <div className={'card-body py-15 w-100 px-10'}>
        {
            /**
             * TIPOS DE INGRESOS
             */
        }
        <div className='row'>
            <div className={'col-md-2 mb-7'}>
                <CajasCompletas formik={formik}></CajasCompletas>
            </div>
            <div className={'col-md-2 mb-7'}>
                <MovimientoSelect formik={formik}></MovimientoSelect>
            </div>
            <div className={'col-md-2 mb-7'}>
                <ConceptoSelect formik={formik}></ConceptoSelect>
            </div>
        </div>
        {
            /**
             * FIN : TIPOS DE INGRESOS
             */
        }
        <TablaCorte data={ingreso}>
            <thead>
            <tr className={'fw-bold text-muted pb-5 text-uppercase text-start'}>
                <th className={'ps-2'}>Fecha</th>
                <th>Capturo</th>
                <th>Movimiento</th>
                <th>Observaciones</th>
                <th>Forma de pago</th>
                <th>Factura</th>
                <th>Monto</th>
            </tr>
            </thead>
            <tbody>
            {
                /**
                 * FILA DE REGISTRO DE INGRESOS O EGRESOS
                 */
            }
            {
                ingreso && ingreso.toReversed().map((i) => {
                    return (
                        <tr key={i.id} className={'text-uppercase text-gray-900 fw-semibold text-start'}>
                            <td className={'align-content-center ps-2'}>{dayjs(i.fecha).format('MMM DD, YYYY')}</td>
                            <td className={'align-content-center'}>{i.capturo}</td>
                            <td className={'align-content-center'}>{i.movimiento === "I" ? (
                                <>
                                    Ingreso
                                    <i className="ki-duotone ki-arrow-down-right fs-4 text-success">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </>
                            ) : (
                                <>
                                    Egreso
                                    <i className="ki-duotone ki-arrow-up-right fs-4 text-primary">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </>
                            )}</td>
                            <td className={'align-content-center'}>{i.observaciones}</td>
                            <td className={'align-content-center'}>{nombreTipoPago(i.forma_pago)}</td>
                            <td className={'align-content-center'}>{i.factura}</td>
                            <td className={'align-content-center'}>
                                  <span className={"fw-bold fs-6"}>
                                      {i.monto}
                                  </span>
                            </td>
                            {
                               dayjs(i.fecha).format('MMM DD, YYYY') === dayjs().format('MMM DD, YYYY') && <td className={'d-flex justify-content-end'}>
                                    <TitleTooltip title={"Borrar"}>
                                        <button onClick={() => handleDeleteRow(i.id)} className="btn btn-sm btn-light-danger btn-icon">
                                            <i className="ki-solid ki-trash fs-5"></i>
                                        </button>
                                    </TitleTooltip>
                                </td>
                            }
                        </tr>
                    );
                })
            }
            {
                /**
                 * FIN : FILA DE REGISTRO DE INGRESOS O EGRESOS
                 */
            }
            </tbody>
        </TablaCorte>
    </div>
  );
}
/////////// FIN COMPONENTE : TABLA DE INGRESOS Y EGRESOS ///////////

function ConceptoSelect({formik}){
    /**
     * @const conceptoRef conteiner para SelectPicker
     * @type {React.MutableRefObject<null>}
     */
    const conceptoRef = useRef(null);
    /**
     * @const data datos para el select
     * @type {[{value: string, label: string},{value: string, label: string},{value: string, label: string},{value: string, label: string}]}
     */
    const data = [
        {
            value : "servicios",
            label : "Pago de servicios"
        },
        {
            value : "contrataciones",
            label :  "Contratos nuevos"
        },
        {
            value : "consultas",
            label : "Consultas",
        },
        {
            value : "otros",
            label : "Otros conceptos",
        },
    ]
    return(
        <>
            <style type={'text/css'}>
                {`
                    #concepto{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #concepto > .rs-stack{
                        display : block!important;
                    }                      
                    #concepto-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #concepto > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #concepto-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #concepto-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #concepto-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>

            <div ref={conceptoRef} className={'position-relative'}>
                <SelectPicker
                    container={() => conceptoRef.current}
                    label={<div className={'labelSelect ps-2'}>Concepto:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width: '100%'}}
                    id={'concepto'}
                    name={'concepto'}
                    value={formik.values.concepto}
                    onChange={(value) => formik.setFieldValue('concepto', value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                    disabled={formik.values.movimiento === "egresos"}
                />
            </div>
        </>
    );
}
function MovimientoSelect({formik}){
    /**
     * @const movRef conteiner para SelectPicker
     * @type {React.MutableRefObject<null>}
     */
    const movRef = useRef(null);
    /**
     * @const data datos del select
     * @type {[{value: string, label: string},{value: string, label: string}]}
     */
    const data = [
        {
            value : "ingresos",
            label : "Ingresos"
        },
        {
            value : "egresos",
            label :  "Gastos"
        },
    ]
    return(
        <>
            <style type={'text/css'}>
                {`
                    #movimiento{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #movimiento > .rs-stack{
                        display : block!important;
                    }                      
                    #movimiento-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #movimiento > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #movimiento-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #movimiento-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #movimiento-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
            </style>
            <div ref={movRef} className={'position-relative'}>
                <SelectPicker
                    container={() => movRef.current}
                    label={<div className={'labelSelect ps-2'}>Movimiento:</div>}
                    data={data}
                    style={{width: "100%"}}
                    menuStyle={{width:'100%'}}
                    id={'movimiento'}
                    name={'movimiento'}
                    value={formik.values.movimiento}
                    onChange={(value) => formik.setFieldValue('movimiento', value)}
                    onBlur={formik.handleBlur}
                    searchable={false}
                    cleanable={false}
                />
            </div>
        </>
    );
}
